/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {EmptyRewardTag} from './constant'

export const getHomepage = createAsyncThunk(
  'SuperLuckyKing/getHomepage',
  async (_, store: any) => {
    const resp = await http.post(
      '/live/activity/lucky_king_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getStageTaskInfo = createAsyncThunk(
  'SuperLuckyKing/getStageTaskInfo',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_stage_task_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getLotteryInfo = createAsyncThunk(
  'SuperLuckyKing/getLotteryInfo',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_lottery_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

const initialState = {
  lotteryIng: false,
  homepage: {
    normal_records: [],
    high_records: [],
  },
  taskD: {
    stages: [],
    stage_score: 0,
    limit: 0,
    isBegin: true,
  },
  lotteryInfo: {
    prize_list: [],
    ticket_num: 0,
  },
}

export const SuperLuckyKingSlice = createSlice({
  name: 'SuperLuckyKing',
  initialState,
  reducers: {
    changeStatus(state, action) {
      state.lotteryIng = action?.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const {data} = action.payload
      state.homepage = data
    })
    builder.addCase(getStageTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      let temp = null
      if (data) {
        temp = {
          ...data,
          stages: [
            {
              stage_no: 0,
              stage_need: 0,
              status: 2,
            },
            ...data?.stages,
          ],
          limit: data?.stages?.[0]?.stage_need,
          isBegin: data?.stage_score >= data?.stages?.[0]?.stage_need,
        }
      }
      state.taskD = temp
    })
    builder.addCase(getLotteryInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      if (data?.prize_list) {
        data.prize_list = data?.prize_list?.filter(
          (item) => item?.reward_tag !== EmptyRewardTag
        )
      }
      state.lotteryInfo = data
    })
  },
})

export const {changeStatus} = SuperLuckyKingSlice.actions
export default SuperLuckyKingSlice.reducer
